import React from 'react';

import { cn } from '@lyearn/style';
import { leftPaddingInput } from '@/components/EditorBuilder/styles';
import TextInput from '@/components/EditorBuilder/TextInput';

import { LessonTitleProps } from './types';

const LessonTitle: React.FC<LessonTitleProps> = (props) => {
  const { className, onPressEnter, onChangeTitle, title, placeholder, color } = props;

  return (
    <TextInput
      autoFocus
      className={cn('px-0', leftPaddingInput, className)}
      color={color}
      data-id="title"
      placeholder={placeholder}
      value={title}
      onChange={onChangeTitle}
      onPressEnter={onPressEnter}
    />
  );
};

export default LessonTitle;
